import animateOnScroll from "./animateOnScroll"

//animate elements
/*---------------
Notes
-----------------
Offset:
- .5 means half of the element is visible before triggering
- 1 means 100% of the element should be visible
- 0 would be if any part of the element is visible 
CSS animations:
- make sure that the transformX/Y is not too large otherwise it will take forever to animate in
*/
animateOnScroll([
    { selector: ".will-item, .fact-item, .problem-wrapper, .solution-wrapper, .cta-wrapper, #NewsGlide, .footer-cta, .hammer", offset: 0.25, multiple: true }
]);